<script>
export default {
	name: "Rule",
	props: {
		isActiveRule: {
			type: Boolean,
			required: true,
		},
	},
	methods: {
		lightboxToggle() {
			// console.log("lightboxToggle")
			const _this = this;
			_this.$emit("update:isActiveRule", false);
		},
	},
};
</script>

<template src="./template.pug" lang="pug"></template>
<style src="./style.sass" lang="sass" scoped>
@import "@/assets/sass/_variable.sass"
@import "@/assets/sass/_mixin.sass"
</style>
